import { createSlice } from "@reduxjs/toolkit";

const node = () => ({ loading: false, error: null, data: null });

const initialState = {
  submissions: node(),
  submission: node(),
  createSubmission: node(),
  deleteSubmission: node(),
};

const spccScreeningSlice = createSlice({
  name: "spccScreening",
  initialState,
  reducers: {
    submissionsStart: (state) => {
      state.submissions.loading = true;
      state.submissions.error = null;
    },
    submissionsSuccess: (state, action) => {
      state.submissions.loading = false;
      state.submissions.data = action.payload;
      state.submissions.error = null;
    },
    submissionsFailure: (state, action) => {
      state.submissions.loading = false;
      state.submissions.error = action.payload;
    },
    submissionsReset: (state) => {
      state.submissions = node();
    },

    submissionStart: (state) => {
      state.submission.loading = true;
      state.submission.error = null;
    },
    submissionSuccess: (state, action) => {
      state.submission.loading = false;
      state.submission.data = action.payload;
      state.submission.error = null;
    },
    submissionFailure: (state, action) => {
      state.submission.loading = false;
      state.submission.error = action.payload;
    },
    submissionReset: (state) => {
      state.submission = node();
    },

    createSubmissionStart: (state) => {
      state.createSubmission.loading = true;
      state.createSubmission.error = null;
    },
    createSubmissionSuccess: (state, action) => {
      state.createSubmission.loading = false;
      state.createSubmission.data = action.payload;
      state.createSubmission.error = null;
    },
    createSubmissionFailure: (state, action) => {
      state.createSubmission.loading = false;
      state.createSubmission.error = action.payload;
    },
    createSubmissionReset: (state) => {
      state.createSubmission = node();
    },

    deleteSubmissionStart: (state) => {
      state.deleteSubmission.loading = true;
      state.deleteSubmission.error = null;
    },
    deleteSubmissionSuccess: (state, action) => {
      state.deleteSubmission.loading = false;
      state.deleteSubmission.data = action.payload;
      state.deleteSubmission.error = null;
    },
    deleteSubmissionFailure: (state, action) => {
      state.deleteSubmission.loading = false;
      state.deleteSubmission.error = action.payload;
    },
    deleteSubmissionReset: (state) => {
      state.deleteSubmission = node();
    },
  },
});

export const {
  submissionsStart,
  submissionsSuccess,
  submissionsFailure,
  submissionsReset,
  submissionStart,
  submissionSuccess,
  submissionFailure,
  submissionReset,
  createSubmissionStart,
  createSubmissionSuccess,
  createSubmissionFailure,
  createSubmissionReset,
  deleteSubmissionStart,
  deleteSubmissionSuccess,
  deleteSubmissionFailure,
  deleteSubmissionReset,
} = spccScreeningSlice.actions;

export default spccScreeningSlice.reducer;
